/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useRef, Fragment, useState, useEffect } from 'react';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { Col, Image, Row } from "antd";
import { Box, Typography } from "@mui/material";
import { TextField } from "@mui/material";
import FileUpload from "../../../../Shared/components/FileUpload";
import { idNamingConversion, currencyFormat } from '../../../../../helpers/utilities';
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import SearchText from '../../../../Shared/components/SearchText';


export const DetailsView = React.forwardRef((props, ref) => {
    const { showDetails, classes, details, clsx } = props;
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [location, setLocation] = useState(details?.byLocation || []);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);



    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                setLocation(details?.byLocation || []);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    const filtered = details.byLocation.filter(item =>
                        item.location?.name?.toLowerCase().includes(search.toLowerCase())
                    );
                    setLocation(filtered || []);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        setLocation(details?.byLocation || [])
    }, [details])

    const checkLocationLength = (data) => {
        if (data && data?.length) {
            const groupedCounts = data?.reduce((acc, { locationId }) => {
                acc[locationId] = (acc[locationId] || 0) + 1;
                return acc;
            }, {});
            return Object.keys(groupedCounts)?.length || 0;
        }
        return 0;
    }


    const childRef = useRef('');
    return (
        <Fragment>
            <CustomAccordion
                title={`Product Details`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline)}
                        component="div" style={{ width: "100%" }}>
                        {
                            !showDetails ?
                                <>
                                    <Row gutter={20}>
                                        <Col xxl={15} xl={15} lg={15} md={15} sm={15} xs={15}>
                                            <Row gutter={20}>
                                                <Col xxl={10} xl={10} lg={8} md={8} sm={10} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize16, classes.bold)}>{details?.byProduct?.product?.productName}</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize13, classes.margin10t, classes.productNameView)}>{details?.byProduct?.product?.productId}{details?.byProduct?.product?.type && <span>{details?.byProduct?.product?.type}</span>}{details?.byProduct?.product?.code && <span>{details?.byProduct?.product?.code}</span>} {details?.byProduct?.product?.transType && <span>{details?.byProduct?.product?.transType === 'SALES' ? 'Sales only' : 'Purchase only'}</span>}</Typography>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={9} xl={9} lg={9} md={9} sm={9} xs={9} style={{ height: "100%" }}>

                                        </Col>
                                    </Row>
                                    <Row type="flex" className={clsx(classes.productFormImageRow)} style={{ height: "calc(100% - 56px)" }} gutter={50}>
                                        <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{details?.byProduct?.product?.description || '---'}</Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{details?.byProduct?.unit?.name || '---'}</Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Unit  Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.physicalQtyUnit || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Unit</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.skuUnit?.name || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.physicalQtySkuUnit || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Ordered Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.ordered || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Supply Ordered Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.supplyOrdered || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Received Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.receivedQty || '---'}</Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Reserved Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.reservedQty || '---'}</Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Picked Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.pickedQty || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Delivered Quantity</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {details?.byProduct?.deliveredQty || '---'}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Cost Amount</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        ₹ {currencyFormat(details?.byProduct?.costAmount || 0)}
                                                    </Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Cost Price</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(details?.byProduct?.costPrice || 0)}</Typography>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={9} xl={9} lg={9} md={24} sm={24} xs={24} style={{ height: "100%" }}>
                                            <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                                <div className={classes.productImageUploadInner}>
                                                    <FileUpload
                                                        filePath={details?.imageUri || ''}
                                                        types={'image/jpeg,image/png,image/gif'}
                                                        maxSize={1}
                                                        square={false}
                                                        text={
                                                            <>
                                                                <p className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>Product Image here</p>
                                                                <p className={clsx(classes.textAreaLableColorUpload, classes.fonSize11)}>(Image size : Not to exceed 1 MB)</p>
                                                            </>
                                                        }
                                                        alt={details?.productName}
                                                        view={true}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </> : <div className={classes.textAlignCenter}>
                                    <div className={classes.loadMoreCircle}></div>
                                </div>
                        }
                    </Box>
                }
            />
            {/* <CustomAccordion
                title={"Prices"}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={<></>}
            /> */}
            <CustomAccordion
                title={"Locations"}
                top={"116"}
                topVisible={"250px"}
                zIndex={5}
                showDetails={showDetails}
                index={2}
                ref={childRef}
                component={
                    <Row>
                        <Col span={5}>
                            <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                <TextField autoComplete='one-time-code'
                                    placeholder='Search Location Name'
                                    type='search'
                                    value={search}
                                    className={classes.comInput}
                                    required
                                    variant={'standard'}
                                    onChange={(e) => setSearch(e.target.value)}
                                    fullWidth
                                    onFocus={() => setIconAnimation(true)}
                                    onBlur={() => setIconAnimation(false)}
                                    id={idNamingConversion('Search', 'stockOnHand', 'TextField')}
                                />
                                <Image src={SearchIcon} preview={false} />
                                {
                                    search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                        <Image
                                            src={ClearIcon}
                                            preview={false}
                                        />
                                    </NavLink>
                                }
                            </div>
                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin20t, classes.typographyHeader, classes.bold)}>{`${checkLocationLength(details?.byLocation)} ${checkLocationLength(details?.byLocation) === 1 ? 'Location' : 'Locations'}`}</Typography>
                        </Col>
                        <Col span={24}>
                            <div className={classes.locationRow}>
                                {
                                    location && location?.length ? location?.map((el, i) => (
                                        <div className={clsx(classes.locationCol)}>
                                            <div className={clsx(classes.locationColInner, classes.locationColYellow, { [classes.locationColBlue]: i % 2 === 0 })}>
                                                <div>{el?.location?.name || ''}</div>
                                                <div className={classes.locationBatch}>
                                                    <div><span>{el?.physicalQtyUnit}</span> {el?.unit?.name}</div>
                                                    {
                                                        el?.batchIds?.length ? <div><span>{el?.batchIds?.length}</span> Batches</div> : ''
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )) : <SearchText />
                                }
                            </div>
                        </Col>
                    </Row>
                }
            />
        </Fragment>
    )
})